module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('symbol', {
    attrs: {
      "id": "icon-cart",
      "viewBox": "0 0 38 32"
    }
  }, [_c('title', [_vm._v("cart")]), _vm._v(" "), _c('path', {
    staticClass: "path1",
    attrs: {
      "d": "M37.759 0h-4.133c-0.733 0.004-1.337 0.549-1.434 1.255l-0.546 4.342c-0.081 0.484-0.496 0.849-0.997 0.849-0.005 0-0.009-0-0.014-0h-27.604c-0.003 0-0.007-0-0.011-0-1.674 0-3.031 1.357-3.031 3.031 0 0.34 0.056 0.666 0.159 0.971l2.52 8.062c0.385 1.194 1.486 2.043 2.785 2.043 0.126 0 0.25-0.008 0.372-0.023l22.983 0.002c0.515 0.131 0.626 0.768 0.626 1.283 0.005 0.044 0.009 0.095 0.009 0.146 0 0.501-0.294 0.933-0.718 1.134l-22.439 0.003c-0.354 0-0.642 0.287-0.642 0.642s0.287 0.642 0.642 0.642h22.745l0.131-0.071c0.919-0.392 1.551-1.287 1.551-2.33 0-0.058-0.002-0.116-0.006-0.173 0.021-0.108 0.033-0.24 0.033-0.376 0-1.072-0.732-1.973-1.724-2.23l-23.357-0.004c-0.063 0.008-0.135 0.013-0.209 0.013-0.719 0-1.332-0.455-1.566-1.093l-2.53-8.095c-0.048-0.154-0.076-0.332-0.076-0.515 0-0.973 0.782-1.764 1.752-1.778h27.657c1.159-0.004 2.112-0.883 2.232-2.011l0.547-4.345c0.010-0.083 0.078-0.147 0.161-0.152l4.133-0c0.354 0 0.642-0.287 0.642-0.642s-0.287-0.642-0.642-0.642z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "path2",
    attrs: {
      "d": "M31.323 9.69c-0.022-0.003-0.048-0.004-0.074-0.004-0.328 0-0.598 0.248-0.633 0.567l-0.809 7.268c-0.003 0.022-0.004 0.048-0.004 0.074 0 0.328 0.248 0.598 0.567 0.633l0.074 0c0.001 0 0.003 0 0.004 0 0.327 0 0.596-0.246 0.632-0.563l0.809-7.268c0.003-0.022 0.004-0.048 0.004-0.074 0-0.328-0.248-0.598-0.567-0.633z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "path3",
    attrs: {
      "d": "M27.514 25.594c-1.769 0-3.203 1.434-3.203 3.203s1.434 3.203 3.203 3.203c1.769 0 3.203-1.434 3.203-3.203s-1.434-3.203-3.203-3.203zM27.514 30.717c-1.060 0-1.92-0.86-1.92-1.92s0.86-1.92 1.92-1.92c1.060 0 1.92 0.86 1.92 1.92s-0.86 1.92-1.92 1.92z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "path4",
    attrs: {
      "d": "M9.599 25.594c-1.769 0-3.203 1.434-3.203 3.203s1.434 3.203 3.203 3.203c1.769 0 3.203-1.434 3.203-3.203s-1.434-3.203-3.203-3.203zM9.599 30.717c-1.060 0-1.92-0.86-1.92-1.92s0.86-1.92 1.92-1.92c1.060 0 1.92 0.86 1.92 1.92s-0.86 1.92-1.92 1.92z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-left-container"
  }, [_c('router-link', {
    attrs: {
      "href": "javascript:void(0)",
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "navbar-brand-logo",
    attrs: {
      "src": "/static/logo1.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-right-container",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "navbar-menu-container"
  }, [_c('span', {
    staticClass: "navbar-link"
  }), _vm._v(" "), (_vm.nickName) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.nickName)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.nickName) ? _c('a', {
    staticClass: "navbar-link",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.loginModalFlag = true
      }
    }
  }, [_vm._v("Login")]) : _vm._e(), _vm._v(" "), (_vm.nickName) ? _c('a', {
    staticClass: "navbar-link",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar-cart-container"
  }, [(_vm.cartCount) ? _c('span', {
    staticClass: "navbar-cart-count"
  }, [_vm._v(_vm._s(_vm.cartCount))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-link navbar-cart-link",
    attrs: {
      "href": "javascript:void(0)",
      "to": "/cart"
    }
  }, [_c('svg', {
    staticClass: "navbar-cart-logo"
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-cart"
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "md-modal modal-msg md-modal-transition",
    class: {
      'md-show': _vm.loginModalFlag
    }
  }, [_c('div', {
    staticClass: "md-modal-inner"
  }, [_c('div', {
    staticClass: "md-top"
  }, [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Login in")]), _vm._v(" "), _c('button', {
    staticClass: "md-close",
    on: {
      "click": function($event) {
        _vm.loginModalFlag = false
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "md-content"
  }, [_c('div', {
    staticClass: "confirm-tips"
  }, [_c('div', {
    staticClass: "error-wrap"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorTip),
      expression: "errorTip"
    }],
    staticClass: "error error-show"
  }, [_vm._v("用户名或者密码错误")])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "regi_form_input"
  }, [_c('i', {
    staticClass: "icon IconPeople"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "regi_login_input regi_login_input_left",
    attrs: {
      "type": "text",
      "tabindex": "1",
      "name": "loginname",
      "placeholder": "User Name",
      "data-type": "loginname"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "regi_form_input noMargin"
  }, [_c('i', {
    staticClass: "icon IconPwd"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPwd),
      expression: "userPwd"
    }],
    staticClass: "regi_login_input regi_login_input_left login-input-no input_text",
    attrs: {
      "type": "password",
      "tabindex": "2",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.userPwd)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPwd = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "login-wrap"
  }, [_c('a', {
    staticClass: "btn-login",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登  录")])])])])]), _vm._v(" "), (_vm.loginModalFlag) ? _c('div', {
    staticClass: "md-overlay",
    on: {
      "click": function($event) {
        _vm.loginModalFlag = false
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd27271c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 84
// module chunks = 0